// Factories
import { BaseStoreFactory } from "../../base/factories/BaseStoreFactory";
/**
 * Factory class for store providers in MetaOS apps
 */
export class MetaOSAppStoreFactory extends BaseStoreFactory {
}
